"use strict";

class PropertyDetailsController {

    constructor($scope, $window, $parse, $filter, $localStorage, $cookies, $timeout, SSHttpService, SSUtilService, SSAlertService, OTPService, SSConfigService, SSUserService, SSAwsService, NgMap) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.$parse = $parse;
        self.$filter = $filter;
        self.$localStorage = $localStorage;
        self.$cookies = $cookies;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;
        self.SSAwsService = SSAwsService;
        self.NgMap = NgMap;

        self.data = SHOWSUITE.data;

        // Property Status
        self.PROPERTY_STATUS_DRAFT = SHOWSUITE.PROPERTY_STATUS_DRAFT; // Just Created
        self.PROPERTY_STATUS_REVIEW = SHOWSUITE.PROPERTY_STATUS_REVIEW; // Submitted for Review
        self.PROPERTY_STATUS_APPROVED = SHOWSUITE.PROPERTY_STATUS_APPROVED; // Approved by the Showsuite Admin
        self.PROPERTY_STATUS_REJECTED = SHOWSUITE.PROPERTY_STATUS_REJECTED; // Rejected by the Showsuite Admin
        self.PROPERTY_STATUS_LISTED = SHOWSUITE.PROPERTY_STATUS_LISTED; // Listed on portal and publicly visible

        self.PROPERTY_DOCUMENT_FORMAT_IMG = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_IMG;

        self.ASSET_MODEL_PROPERTY_ACCOUNT_QRC = SHOWSUITE.ASSET_MODEL_PROPERTY_ACCOUNT_QRC;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.language = self.$localStorage['language'];
        self.localizeParam = {
            name: '',
            display_address:''
        };
        self.selectedLanguage = '';
        self.mrtFormat = [];
        self.schoolFormat = [];
        self.mrtMaster = [];
        self.schoolMaster = [];

        self.multiSelectSettings =
        {
                idProperty: 'id',
                styleActive: true
        };

        self.getProperty();
        self.getPropertyAccount();
        self.getPropertyMrts();
        self.getPropertySchools();

        self.banks = self.SSConfigService.getBanks();
        self.account_types = self.SSConfigService.getPropertyAccountTypes();
        //populate mrt data
        self.mrtStationsList= self.SSConfigService.getMrts();

        jQuery.each(self.mrtStationsList, function(i, mrt){
            self.mrtMaster.push({id:mrt.id, label:mrt.name + " ["+mrt.line_name+"]"});
        });

        //populate school data
        self.schoolsList= self.SSConfigService.getSchools();

        jQuery.each(self.schoolsList, function(i, school){
            self.schoolMaster.push({id:school.id, label:school.name});
        });

        self.available = [];
        self.selected = [];
        self.availableSchools = [];
        self.selectedSchools = [];

        self.moveItem = function(items, from, to) {

            angular.forEach(items, function(item) {
                var idx = from.indexOf(item);
                from.splice(idx, 1);
                to.push(item);
            });

            // clear selection
            self.available = "";
            self.selected = "";
            self.availableSchools = "";
            self.selectedSchools = "";
        };

        self.moveAll = function(from, to) {

            angular.forEach(from, function(item) {
                to.push(item);
            });
            from.length = 0;
        };

        self.selectedclients = [];
    }

    getLocalizationValue(table ,id, column_name){
        const self = this;
        if(!table || !id || !column_name)
            return;
        if(self.language){
            let result = self.language.filter(function (row) {

                return table+'.'+id+'.'+column_name+'.'+self.selectedLanguage == row.key;
            });
            if(result.length)
                return result[0].value;
            else
                return '';
        }
    }

    createLocalizationKey(table ,id, column_name){
        const self = this;
        if(!table || !id || !column_name)
            return;
        return table+'.'+id+'.'+column_name+'.'+self.selectedLanguage;
    }

    convertLocalizationParams(){
        const self = this;
        let params = {};
        params[self.createLocalizationKey('properties',self.property.id,'name')] = self.localizeParam.name;
        params[self.createLocalizationKey('properties',self.property.id,'location')] = self.localizeParam.display_address;
        params[self.createLocalizationKey('properties',self.property.id,'sales_contact_name')] = self.localizeParam.sales_contact_name;
        params[self.createLocalizationKey('properties',self.property.id,'showflat_address')] = self.localizeParam.showflat_address;
        params[self.createLocalizationKey('properties',self.property.id,'developer_legal_name')] = self.localizeParam.developer_legal_name;
        params[self.createLocalizationKey('properties',self.property.id,'architect')] = self.localizeParam.architect;
        params[self.createLocalizationKey('properties',self.property.id,'builder')] = self.localizeParam.builder;
        params[self.createLocalizationKey('properties',self.property.id,'short_description')] = self.localizeParam.short_description;
        params[self.createLocalizationKey('properties',self.property.id,'description')] = self.localizeParam.description;
        params[self.createLocalizationKey('properties',self.property.id,'footnote')] = self.localizeParam.footnote;
        params[self.createLocalizationKey('properties',self.property.id,'facilities')] = self.localizeParam.facilities;
        params[self.createLocalizationKey('properties',self.property.id,'clubhouse_facilities')] = self.localizeParam.clubhouse_facilities;
        params[self.createLocalizationKey('properties',self.property.id,'nearby_bus_station')] = self.localizeParam.nearby_bus_station;
        params[self.createLocalizationKey('properties',self.property.id,'shopping_malls')] = self.localizeParam.shopping_malls;
        params[self.createLocalizationKey('properties',self.property.id,'places_of_interest')] = self.localizeParam.places_of_interest;
        params[self.createLocalizationKey('properties',self.property.id,'recreation')] = self.localizeParam.recreation;
        return params;
    }

    selectLanguageChanged(){
        const self = this;
        //Adding data to localizeParams
        self.localizeParam.name = self.getLocalizationValue('properties',self.property.id,'name');
        self.localizeParam.display_address = self.getLocalizationValue('properties',self.property.id,'location');
        self.localizeParam.sales_contact_name = self.getLocalizationValue('properties',self.property.id,'sales_contact_name');
        self.localizeParam.showflat_address = self.getLocalizationValue('properties',self.property.id,'showflat_address');
        self.localizeParam.developer_legal_name = self.getLocalizationValue('properties',self.property.id,'developer_legal_name');
        self.localizeParam.architect = self.getLocalizationValue('properties',self.property.id,'architect');
        self.localizeParam.builder = self.getLocalizationValue('properties',self.property.id,'builder');
        self.localizeParam.short_description = self.getLocalizationValue('properties',self.property.id,'short_description');
        self.localizeParam.description = self.getLocalizationValue('properties',self.property.id,'description');
        self.localizeParam.footnote = self.getLocalizationValue('properties',self.property.id,'footnote');
        self.localizeParam.facilities = self.getLocalizationValue('properties',self.property.id,'facilities');
        self.localizeParam.clubhouse_facilities = self.getLocalizationValue('properties',self.property.id,'clubhouse_facilities');
        self.localizeParam.nearby_bus_station = self.getLocalizationValue('properties',self.property.id,'nearby_bus_station');
        self.localizeParam.shopping_malls = self.getLocalizationValue('properties',self.property.id,'shopping_malls');
        self.localizeParam.places_of_interest = self.getLocalizationValue('properties',self.property.id,'places_of_interest');
        self.localizeParam.recreation = self.getLocalizationValue('properties',self.property.id,'recreation');
    }

    saveLanguageParam(){
        const self = this;

        if(!self.selectedLanguage){
            self.selectedLanguageError = 'Select Language to save';
            return;
        }

        let params = self.convertLocalizationParams();

        let url = 'language';

        loading(true);
        self.SSHttpService.postAPIRequest(url,params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            
            self.SSAlertService.success('Success!', 'All data is saved successfully.');
            self.updateLocalLanguage();
        });
    }

    updateLocalLanguage(){
        const self = this;
        let url = 'language';

        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.$localStorage['language'] = response.data.language;
            // self.language = SHOWSUITE.data.language;
            self.$cookies.put('language-md5', response.data.md5);
        });
    }

    getProperty() {
        const self = this;

        if (!self.data.property_id)
            return;

        self.property = null;
        self.propertyParams = null;

        let url = 'sec/developer/properties/' + self.data.property_id;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.property = response.data.property;
            self.propertyParams = angular.copy(self.property);

            self.totalSiteAreaSqf = self.propertyParams.site_area_residential_sqf + self.propertyParams.site_area_commercial_sqf;
            self.totalSiteAreaSqm = self.propertyParams.site_area_residential_sqm + self.propertyParams.site_area_commercial_sqm;

            //Adding data to localizeParams
            self.localizeParam.name = self.getLocalizationValue('properties',self.property.id,'name');

            if (self.propertyParams.launch_date === "0000-00-00") {
                self.propertyParams.launch_date = '';
            }
            if (self.propertyParams.launch_end_date && self.propertyParams.launch_end_date === "0000-00-00") {
                self.propertyParams.launch_end_date = '';
            }
            if (self.propertyParams.construction_date === "0000-00-00") {
                self.propertyParams.construction_date = '';
            }
            if (self.propertyParams.construction_date_updated_at === "0000-00-00") {
                self.propertyParams.construction_date_updated_at = '';
            }
            if (self.propertyParams.lease_effective_date === "0000-00-00") {
                self.propertyParams.lease_effective_date = '';
            }
            if (self.propertyParams.vacant_possession_date === "0000-00-00") {
                self.propertyParams.vacant_possession_date = '';
            }

            self.maskPhoneNumber(self, 'ctrl.', 'propertyGeneralDetails');
            jQuery('.datepicker').datepicker({
                dateFormat: "yy-mm-dd"
            }).val('');
        });
    }

    getPropertyMrts() {
        const self = this;
        self.selectedMrt = [];

        if (!self.data.property_id)
            return;

        self.property = null;
        self.propertyParams = null;

        let url = 'sec/developer/properties/' + self.data.property_id + '/get-mrt-stations';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.propMrts = response.data.mrtStations;

            jQuery.each(self.mrtMaster, function(i, Mrts){
                if (!(self.propMrts.find(x => x.id === Mrts.id))) {
                    self.mrtFormat.push({id: Mrts.id, label: Mrts.label});
                }
            });
            self.mrtFormat = self.$filter('orderBy')(self.mrtFormat, "label");

            self.mrtCount = self.propMrts.length;
            jQuery.each(self.propMrts, function(i, mrt){
                self.selectedMrt.push({id:mrt.id, label:mrt.name + " ["+mrt.line_name+"]" });
            });

            self.mrtStations = self.propMrts
                .map(function (d) {
                    return d.name + " ["+d.line_name+"]";
                })
                .join('\n');

        });
    }

    getPropertySchools() {
        const self = this;
        self.selectedSchool = [];

        if (!self.data.property_id)
            return;

        self.property = null;
        self.propertyParams = null;

        let url = 'sec/developer/properties/' + self.data.property_id + '/get-schools';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.propSchools = response.data.schools;

            jQuery.each(self.schoolMaster, function(i, school){
                if (!(self.propSchools.find(x => x.id === school.id))) {
                    self.schoolFormat.push({id: school.id, label: school.label});
                }
            });

            self.schoolFormat = self.$filter('orderBy')(self.schoolFormat, "label");

            self.schoolCount = self.propSchools.length;
            jQuery.each(self.propSchools, function(i, school){
                self.selectedSchool.push({id:school.id, label:school.name});
            });

            self.schools = self.propSchools
                .map(function (d) {
                    return d.name;
                })
                .join('\n');

        });
    }

    maskPhoneNumber(context, contextPrefix, formId) {
        let self = this;

        if (!context) {
            return;
        }

        let parent = null;
        if (formId) {
            parent = jQuery('#' + formId);
        } else {
            parent = jQuery('body');
        }

        jQuery.each(parent.find('input[type=tel]'), function (i, el) {
            let field = jQuery(el);

            let allowDropdown = field.attr('allowDropdown');
            allowDropdown = !allowDropdown || allowDropdown !== 'false';

            field.intlTelInput({
                initialCountry: 'sg',
                geoIpLookup: self.SSUtilService.geoIpLookup,
                allowDropdown: allowDropdown,
                preferredCountries: ['sg']
            });

            let model = field.attr('ng-model');
            if (model) {
                if (startsWith(model, contextPrefix)) {
                    model = model.substring(contextPrefix.length);
                }
                let value = self.$parse(model)(context);
                if (value) {
                    field.intlTelInput('setNumber', value);
                }
            }


            field.on("keyup change", function () {
                field.parent().removeClass("has-error");
            });
            field.blur(function () {
                var currentFormat = (field.val() && field.val()[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
                field.val(field.intlTelInput("getNumber", currentFormat));

                field.parent().removeClass("has-error");
                if (!field.intlTelInput("isValidNumber")) {
                    field.parent().addClass("has-error");
                    if (model) {
                        //self.$parse(model).assign(context, ""); // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
                    }
                } else {
                    if (model) {
                        self.$parse(model).assign(context, field.intlTelInput("getNumber"));
                    }
                }
            });
        });

    }

    saveProject() {
        const self = this;

        // Validate Required Data
        if (!self.SSUtilService.validateForm(self, 'ctrl', jQuery('#propertyGeneralDetails'))) {
            self.SSAlertService.danger('Invalid Data!', 'Please fill in the required information.');
            return;
        }

        let hasChanges = self.SSUtilService.hasChanges(self.property, self.propertyParams);
        if (!hasChanges) {
            self.SSAlertService.info('Info!', 'Nothing modified.');
            return;
        }

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function () {

                let url = 'sec/developer/properties/' + self.propertyParams.id + '/update';
                let params = self.propertyParams;
                
                params.site_area_sqm = self.totalSiteAreaSqm;
                params.site_area_sqf = self.totalSiteAreaSqf;

                self.propertyErrors = {};

                loading(true);
                self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        self.propertyErrors = self.SSHttpService.parseErrors(response);
                        return;
                    }

                    self.SSAlertService.success('Success!', 'Project information saved successfully.');

                    self.property = response.data.property;
                    self.propertyParams = angular.copy(self.property);
                });
            }
        );
    }

    savePropertyAccounts() {
        const self = this;
        self.property_bank_account_error = {};
        let url = 'sec/developer/properties/' + self.propertyParams.id + '/add-property-account';
        let params = {
            bank_name: self.bank_name,
            account_name: self.account_name,
            account_no: self.account_no,
            account_type:self.account_type,
            bank_code:self.bank_code,
            uen:self.uen,
            qrc_uri: self.qrc_url? self.qrc_url: null
        };
        if(!self.isValidPropertyBankAccountInput(params)){
            return;
        }
        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.property_bank_account_error = self.SSHttpService.parseErrors(response);
                return;
            }

                if(response.data.propertyAccount.qrc_uri){
                    self.getPresignedUrl(response.data.propertyAccount);
                }
                self.propertyAccount.push(response.data.propertyAccount);
                $('#PropertyAccountsOtpModal').modal('hide');
                self.SSAlertService.successPop('Success!', 'Property Bank Account saved successfully.');


        });

    }

    updatePropertyAccounts(account) {
        const self = this;
        self.property_bank_account_error = {};
        if(!self.isValidPropertyBankAccountInput(account)){
            return;
        }
        let url = 'sec/developer/properties/' + self.propertyParams.id + '/update-property-account';

        let params = {
           id: account.id,
            bank_name: account.bank_name,
            bank_code: account.bank_code,
            account_name: account.account_name,
            account_no: account.account_no,
            account_type : account.account_type,
            uen: account.uen,
            qrc_uri: account.qrc_uri? account.qrc_uri: null,

        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.property_bank_account_error = self.SSHttpService.parseErrors(response);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.propertyAccount[self.arr_id] = account;
            $('#PropertyAccountsOtpModal').modal('hide');
            self.SSAlertService.successPop('Success!', 'Property Bank Account updated successfully.');
        });

    }
    isValidPropertyBankAccountInput(propertyBankAccountParam){
        const self = this;

        let isValid = true;

        if(!propertyBankAccountParam.account_type){
            self.property_bank_account_error.account_type = "The account type field is required.";
            isValid = false;
        }

        if(!propertyBankAccountParam.bank_name){
            self.property_bank_account_error.bank_name = "The bank name field is required.";
            isValid = false;
        }

        if(!propertyBankAccountParam.bank_code){
            self.property_bank_account_error.bank_code = "The bank code field is required.";
            isValid = false;
        }

        if(!propertyBankAccountParam.account_name){
            self.property_bank_account_error.account_name = "The account name field is required.";
            isValid = false;
        }

        if(!propertyBankAccountParam.account_no){
            self.property_bank_account_error.account_no = "The account no field is required.";
            isValid = false;
        }


        return isValid;
    }

    setDefaultCreditingAccount(account, id) {
        const self = this;
        self.arr_id = id;

        let url = 'sec/developer/properties/' + self.propertyParams.id + '/set-default-crediting-account';

        let params = {
           id: account.id,
           default_crediting_account: account.default_crediting_account,
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.propertyAccount[self.arr_id] = account;
            self.SSAlertService.successPop('Success!', 'Default crediting account set successfully.');
        });

    }

    getPropertyAccount() {
        const self = this;

        let url = 'sec/developer/properties/' + self.data.property_id + '/get-property-account';
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.propertyAccount = response.data.propertyAccount;

            $.each(self.propertyAccount, function(index,propertyAcc){
                if(propertyAcc.qrc_uri){
                    self.getPresignedUrl(propertyAcc);
                }

            });
        });

    }

    getPresignedUrl(propertyAccount){
        const self = this;
        let url = 'sec/assets/presigned-url';
        let params = {
            'model': self.ASSET_MODEL_PROPERTY_ACCOUNT_QRC,
            'id': propertyAccount.id,
        };
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            propertyAccount.qrc_url = response.data.presigned_url;
        });
    }

    deleteBankAccount(account, id){
        const self = this;
        if(!account)
            return;

        let params = {
            id: account.id
        };
        let url = 'sec/developer/properties/' + self.propertyParams.id + '/delete-property-account';
        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.propertyAccount.splice(id,1);
            self.SSAlertService.successPop('Success!', 'Property Bank Account deleted successfully.');
        });
    }

    addBankAccount() {
        const self = this;
        self.SSAlertService.messagePop = null;
        self.editmode = false;
        self.account = null;
        self.arr_id = null;
        self.edit = null;
        self.bank_name = "";
        self.account_name = "";
        self.account_no = null;
        self.account_type = null;
        self.bank_code = null;
        self.uen = null;
        self.qrc_url = null;
        self.qrc_uri = null;
        self.property_bank_account_error = {};
        $('#PropertyAccountsOtpModal').modal('show');
    }

    manageMrts() {
        const self = this;
        self.SSAlertService.messagePop = null;

        $('#PropertyMrtModal').modal('show');
    }

    manageSchools() {
        const self = this;

        $('#PropertySchoolModal').modal('show');
    }

    updateMrts(){
        const self = this;
        var deleteMrts = [];
        var addMrts = [];

        jQuery.each(self.propMrts, function(i, mrt){
            if (!(self.selectedMrt.find(x => x.id === mrt.id))) {
                deleteMrts.push(mrt.id);
            }
        });

        jQuery.each(self.selectedMrt, function(i, mrt){
            if (!(self.propMrts.find(x => x.id === mrt.id))) {
                addMrts.push(mrt.id);
            }
        });

        if(addMrts.length > 0) {
            self.addMrts(addMrts);
        }
        if(deleteMrts.length > 0) {
            self.deleteMrts(deleteMrts);
        }

        self.mrtCount = self.selectedMrt.length;

        self.mrtStations = self.selectedMrt
            .map(function (d) {
                return d.label;
            })
            .join('\n');

        self.propertyMrts = angular.copy(self.selectedMrt);

        self.propMrts = self.propertyMrts;
        $('#PropertyMrtModal').modal('hide');
        self.SSAlertService.success('Success!', 'Mrt updated successfully.');

    }

    updateSchools(){
        const self = this;
        var deleteSchools = [];
        var addSchools = [];

        jQuery.each(self.propSchools, function(i, school){
            if (!(self.selectedSchool.find(x => x.id === school.id))) {
                deleteSchools.push(school.id);
            }
        });

        jQuery.each(self.selectedSchool, function(i, school){
            if (!(self.propSchools.find(x => x.id === school.id))) {
                addSchools.push(school.id);
            }
        });

        if(addSchools.length > 0) {
            self.addSchools(addSchools);
        }
        if(deleteSchools.length > 0) {
            self.deleteSchools(deleteSchools);
        }

        self.schoolCount = self.selectedSchool.length;

        self.schools = self.selectedSchool
            .map(function (d) {
                return d.label;
            })
            .join('\n');

        self.propertySchools = angular.copy(self.selectedSchool);

        self.propSchools = self.propertySchools;
        $('#PropertySchoolModal').modal('hide');
        self.SSAlertService.success('Success!', 'School updated successfully.');

    }

    addMrts(addMrts){
        const self = this;

        if(!addMrts)
            return;

        let params = {
            id: addMrts.join(",")
        };

        let url = 'sec/developer/properties/' + self.propertyParams.id + '/add-mrt-stations';
        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
        });


    }

    addSchools(addSchools){
        const self = this;

        if(!addSchools)
            return;

        let params = {
            id: addSchools.join(",")
        };

        let url = 'sec/developer/properties/' + self.propertyParams.id + '/add-schools';
        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
        });


    }

    deleteMrts(deleteMrts){

        const self = this;

        if(!deleteMrts)
            return;

        let params = {
            id: deleteMrts.join(",")
        };

        let url = 'sec/developer/properties/' + self.propertyParams.id + '/delete-mrt-stations';
        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
        });


    }

    deleteSchools(deleteSchools){

        const self = this;

        if(!deleteSchools)
            return;

        let params = {
            id: deleteSchools.join(",")
        };

        let url = 'sec/developer/properties/' + self.propertyParams.id + '/delete-schools';
        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
        });


    }

   editBankAccount(account, id) {
        const self = this;
        self.SSAlertService.messagePop = null;
        self.account = account;
        self.arr_id = id;
        self.editmode = true;
        self.edit = angular.copy(account);

        $('#PropertyAccountsOtpModal').modal('show');

    }

    convertSQMToSQFTResidential() {
        const self = this;

        self.propertyParams.site_area_residential_sqf = Math.round(self.propertyParams.site_area_residential_sqm * 10.7639);

         self.totalSiteAreaSqf = self.propertyParams.site_area_residential_sqf + self.propertyParams.site_area_commercial_sqf;
         self.totalSiteAreaSqm = self.propertyParams.site_area_residential_sqm + self.propertyParams.site_area_commercial_sqm;

    }

    convertSQFTToSQMResidential() {
        const self = this;

        self.propertyParams.site_area_residential_sqm = Math.round(self.propertyParams.site_area_residential_sqf * 0.092903);

        self.totalSiteAreaSqf = self.propertyParams.site_area_residential_sqf + self.propertyParams.site_area_commercial_sqf;
        self.totalSiteAreaSqm = self.propertyParams.site_area_residential_sqm + self.propertyParams.site_area_commercial_sqm;
    }


    convertSQMToSQFTCommercial() {
        const self = this;

        self.propertyParams.site_area_commercial_sqf = Math.round(self.propertyParams.site_area_commercial_sqm * 10.7639);

        self.totalSiteAreaSqf = self.propertyParams.site_area_residential_sqf + self.propertyParams.site_area_commercial_sqf;
        self.totalSiteAreaSqm = self.propertyParams.site_area_residential_sqm + self.propertyParams.site_area_commercial_sqm;
    }

    convertSQFTToSQMCommercial() {
        const self = this;

        self.propertyParams.site_area_commercial_sqm = Math.round(self.propertyParams.site_area_commercial_sqf * 0.092903);

        self.totalSiteAreaSqf = self.propertyParams.site_area_residential_sqf + self.propertyParams.site_area_commercial_sqf;
        self.totalSiteAreaSqm = self.propertyParams.site_area_residential_sqm + self.propertyParams.site_area_commercial_sqm;
    }


    /* Start: Co-Developers */

    searchDeveloper() {
        const self = this;

        if (!self.search_developer_params_email)
            return;

        let url = 'sec/developer/co-developers/search';
        let params = {
            email: self.search_developer_params_email
        };

        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                self.search_developer_error = 'Oops! Something went wrong. Please try again.';
                return;
            }

            self.search_developer = null;
            if (!response.data.developer) {
                self.search_developer_error = 'No results found.';
            } else {
                self.search_developer = response.data.developer;
            }
        });

    }

    validateCoDeveloper() {
        const self = this;

        if (!self.search_developer)
            return;

        if (self.search_developer.id == self.property.developer_id) {
            return false;
        }

        let valid = true;
        jQuery.each(self.property.developers, function (i, developer) {
            if (self.search_developer.id == developer.id) {
                valid = false;
                return false;
            }
        });

        return valid;
    }

    addCoDeveloper() {
        const self = this;

        if (!self.search_developer)
            return;

        let url = 'sec/developer/co-developers/add';
        let params = {
            property_id: self.property.id,
            developer_id: self.search_developer.id
        };

        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                return;
            }

            self.property.developers = response.data.developers;
            self.search_developer = null;
            self.search_developer_params_email = null;
        });
    }

    removeCoDeveloper(developerId) {
        const self = this;

        if (!developerId)
            return;

        let url = 'sec/developer/co-developers/remove';
        let params = {
            property_id: self.property.id,
            developer_id: developerId
        };

        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                return;
            }

            self.property.developers = response.data.developers;
        });

    }

    /* End: Co-Developers */

    setPropertyOnMap() {
        const self = this;

        self.NgMap.getMap().then(function (map) {
            self.map = map;

            self.$timeout(function () {
                let infowindow = new google.maps.InfoWindow();

                if (self.original_marker) {
                    self.original_marker.setMap(null);
                }
                self.original_marker = null;
                let i;

                if (self.propertyParams.lat)
                    self.currentLatitude = self.propertyParams.lat;
                else
                    self.currentLatitude = 1.3521;

                if (self.propertyParams.long)
                    self.currentLongitude = self.propertyParams.long;
                else
                    self.currentLongitude = 103.8198;

                self.original_marker = new google.maps.Marker({
                    position: {lat: self.currentLatitude, lng: self.currentLongitude},
                    animation: google.maps.Animation.DROP,
                    map: self.map,
                    draggable:true
                });

                google.maps.event.addListener(self.original_marker, 'click', (function (marker, i) {
                    return function () {
                        infowindow.setContent(infoWindowContent);
                        infowindow.open(self.map, marker);
                    }
                })(self.original_marker, i));

                google.maps.event.addListener(self.original_marker, 'dragend', function(marker) {
                    self.currentLatitude = marker.latLng.lat();
                    self.currentLongitude = marker.latLng.lng();
                });
                google.maps.event.trigger(self.map, 'resize');
            });
        });
    }

    viewMap() {
        const self = this;

        self.map = null;
        self.setPropertyOnMap();
        $('#propertyMapModal').modal('show');
    }

    updatePin() {
        const self = this;

        self.propertyParams.lat = self.currentLatitude;
        self.propertyParams.long = self.currentLongitude;

        if ($('#propertyMapModal').is(':visible')) $('#propertyMapModal').modal('hide');
    }

    // Methods to upload QR code image
    uploadNewDocumentFiles(files) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload image file only');
            return;
        }
        let policyUrl = 'sec/developer/properties/' + self.property.id + '/s3-policy-document';

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {

            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);

                return;
            }
            loading(false);
            var reader = new FileReader();
            reader.onload = function(event) {
                if(!self.editmode){
                    self.qrc_uri = event.target.result;
                }
                else{
                    self.edit.qrc_url = event.target.result;
                }
                self.$scope.$apply();

            }
            // when the file is read it triggers the onload event above.
            reader.readAsDataURL(file);
            if(!self.editmode){
                self.qrc_url = response.config.data.key;
            }
            else{
                self.edit.qrc_uri = response.config.data.key;
            }
        });
    }

    removeQRDocument(){
        const self = this;
        if(self.editmode){
            if(!self.edit.qrc_url) return;
            self.edit.qrc_uri = null;
            self.edit.qrc_url = null;
            return;
        }
        else{
            if(!self.qrc_uri) return;
            self.qrc_uri = null;
            self.qrc_url = null;
        }

    }
}

PropertyDetailsController.$inject = ['$scope', '$window', '$parse', '$filter', '$localStorage', '$cookies', '$timeout', 'SSHttpService', 'SSUtilService', 'SSAlertService', 'OTPService', 'SSConfigService', 'SSUserService', 'SSAwsService', 'NgMap'];
app.controller('PropertyDetailsController', PropertyDetailsController);

